var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":"auto","viewBox":"0 0 13 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.3444 3.28285L6.81948 5.75793L11.7685 0.80835M1.42773 3.28285L3.90282 5.75793M8.8524 0.80835L6.9694 2.70827","stroke":_vm.color,"stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }